<template>
 <v-expansion-panel class="mt-3">
    <v-expansion-panel-content
    >
      <template v-slot:header>
        <div class="subheading">Verknüpfte Betriebe in Ihren Innungen</div>

      </template>
       <v-card
    class="mt-2"
    flat
  >
   
    <v-card-text class="subheading">
      Hier können Sie sehen, welche Betriebe mit den Innungen verknüpft sind, die Sie verwalten.<br><br>
      Diese Ansicht ist nur für Admins verfügbar.
    </v-card-text>
    <v-card-text class="caption">

      <v-layout
        row
        wrap
      >
        <v-flex
          xs12
          v-for="kalender in this.kalender"
          :key="kalender.id"
          mb-4
        >
          <h3 class="title mt-3">Kalender: {{ kalender.name }}</h3>

          <v-layout row v-if="kalender.innung">
            <v-flex>
              <v-card
                class="elevation-1 mt-3 mb-2 ml-1 pt-2"
                max-width="200px"
              >
                <v-img
                  height="130px"
                  contain
                  :src="kalender.innung.logo"
                ></v-img>
                <v-card-title class="subheading">{{ kalender.innung.name }}</v-card-title>
               
              </v-card>
            </v-flex>
          </v-layout>


          <v-layout
            row
            wrap
            v-if="kalender.innung"
          >
            <v-flex
              xs6
              md4
              lg3
              v-for="betrieb in kalender.innung.betriebe"
              :key="betrieb.id"
            >
              <v-card
                flat
                class=" transparent ma-2"
                 :to="{name: 'showCompany', params: { id: betrieb.slug }}"
              >{{ betrieb.name }}</v-card>
            
            </v-flex>
             <v-divider></v-divider>
          </v-layout>
 
          <span v-if="kalender.innungen">
            <v-layout
              row
              wrap
              v-for="innung in kalender.innungen"
              :key="innung.id"
            >
              <v-layout row>
                <v-flex xs12>
                  <v-card
                    class="elevation-1 mt-4 mb-2 ml-1 pt-2"
                    max-width="200px"
                    v-if="innung"
                  >
                    <v-img
                      height="130px"
                      contain
                      :src="innung.logo"
                    ></v-img>
                    <v-card-title class="subheading">{{ innung.name }}</v-card-title>
                  </v-card>
                 
                </v-flex>
               
              </v-layout>
              <v-layout
                row
                wrap
                v-if="innung"
              >
                <v-flex
                  xs6
                  md4
                  lg3
                  v-for="betrieb in innung.betriebe"
                  :key="betrieb.id"
                >
                  <v-card
                    flat
                    class="transparent ma-2"
                     :to="{name: 'showCompany', params: { id: betrieb.slug }}"
                  >{{ betrieb.name }}</v-card>
                </v-flex>

              </v-layout>
                <v-divider></v-divider>
            </v-layout>
          </span>

        </v-flex>
      </v-layout>
      <!-- 
      <br><br>
   lölölölöl {{ this.kalender }} -->
    </v-card-text>
    <!-- <v-card-text>
      {{ this.kalender }}
    </v-card-text> -->
  </v-card>
    </v-expansion-panel-content>
 </v-expansion-panel>
 
</template>

<script>
export default {
  // props: ['events', 'intern'],
  props: {
    kalender: Array
  },
  components: {
    // AnfrageVerstecken
  },
  computed: {
    // BetriebVorhanden: function () {
    //   if (this.$store.getters.authBetrieb) {
    //     if (this.$store.getters.authBetrieb.name) return true
    //   } else {
    //     return false
    //   }
    // },
    // InnungsFarbe: function () {
    //   if (this.innung) {
    //     if (this.innung.eigenerkalender) {
    //       if (this.innung.eigenerkalender.color) {
    //         return this.innung.eigenerkalender.color
    //       } else { return 'accent' }
    //     } else { return 'accent' }
    //   } else { return 'accent' }
    // },
    // InnungsDunklerText: function () {
    //   if (this.innung) {
    //     if (this.innung.eigenerkalender) {
    //       if (this.innung.eigenerkalender.dunklertext) {
    //         return this.innung.eigenerkalender.dunklertext
    //       } else { return false }
    //     } else { return false }
    //   } else { return false }
    // }
  },
  mounted: function () {},
  methods: {}
}
</script>

<style>
</style>